import {routes} from './orientacao.routes';
import OrientacaoListController from "./directory/directory.controller";
import OrientacaoService from "./orientacao.service";
import OrientacaoDetailsController from "./details/details.controller";
import OrientacaoCreateOrientacaoController from "./new/new.controller";

export default angular.module('app.orientacao', [])
  .config(routes)
  .controller('OrientacaoListController', OrientacaoListController)
  .service('OrientacaoService', OrientacaoService)
  .controller('OrientacaoDetailsController', OrientacaoDetailsController)
  .controller('OrientacaoCreateOrientacaoController', OrientacaoCreateOrientacaoController)
  .name;
